import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Storage } from '@ionic/storage';

@Component({
  selector: 'inc-fire-user',
  templateUrl: './fire-user.component.html',
  styleUrls: ['./fire-user.component.scss'],
})
export class FireUserComponent implements OnInit {
  email: string;

  constructor(private router: Router, private storage: Storage) { }

  ngOnInit() {
    this.setEmail();
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) { this.setEmail(); }
    });
  }

  navTo(dest: string) {
    this.router.navigateByUrl('' + dest);
  }

  setEmail() {
    this.storage.get('user').then((user) => {
      if (user) {
        this.email = user.email;
      }
    });
  }

}
